import { render } from "./LayoutAdmin.vue?vue&type=template&id=55ae0c23"
import script from "./LayoutAdmin.vue?vue&type=script&lang=js"
export * from "./LayoutAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__